var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/sub-menu.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-61b5d89c!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/sub-menu.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/SubMenu.vue
// module id = 44
// module chunks = 1